export default {
  // apiURL: "https://api.ibranch.test/?rest_route=/",
  // apiURL: "https://api.ibranch.io/?rest_route=/",
  apiURL:
    process.env.NODE_ENV === "development"
      ? "https://api.ibranch.test/?rest_route=/"
      : "https://api.ibranch.io/?rest_route=/",
  jwt_auth: "ibranch/v1/authenticate",
  jwt_validate: "ibranch/v1/validate-jwt",
  jwt_refresh: "ibranch/v1/refresh-jwt",
  apiPath: "ibranch/v1/",
};
